import { Divider } from "react-native-paper";
import {
    Headline,
    NumberInput,
    Spacer,
    StyleFunction,
    Table,
    Text,
    useTheme,
    useThemedStyle,
} from "@venuepos/react-common";

import { produce } from "immer";
import type { IMerchantChartOfAccountInput } from "lib";
import { useTranslation } from "locales";
import React, { View } from "react-native";

export function ChartOfAccounts(props: {
    chartOfAccounts: IMerchantChartOfAccountInput[];
    setValue: any;
}) {
    const [t] = useTranslation();
    const theme = useTheme();
    const styles = useThemedStyle(styleFunc);
    const { chartOfAccounts, setValue } = props;

    const changeMerchantAccountNo = (
        merchantAccountNo: number,
        existingMerchantAccountNo: number
    ) => {
        setValue(
            "generalAccountMap",
            produce(chartOfAccounts, draft => {
                const item = draft.find(
                    itr => itr.merchantAccountNo === existingMerchantAccountNo
                );

                if (item) {
                    item.merchantAccountNo = merchantAccountNo;
                }
            })
        );
    };

    return (
        <View style={styles.container}>
            <Headline size="h4">
                {t(
                    "backoffice.integration.economic.merchant_account_chart",
                    "Chart of accounts"
                )}
            </Headline>
            <View>
                <Text>
                    {t(
                        "backoffice.integration.economic.merchant_account_chart_description",
                        "The general chart of accounts is used for bookkeeping a shift in e-conomic. When the sale is summed up, it is spread on the accounts below which relates to the product groups.\n\nE.g if a product does not have a related account number, then this sale is transferred to 'Salg af varer/ydelser' m/u moms."
                    )}
                </Text>
            </View>
            <Spacer />
            <Divider />
            {chartOfAccounts && chartOfAccounts.length > 0 ? (
                <Table>
                    <Table.Header>
                        <Table.Title>
                            {t("common.chart_of_accounts_name", "Account name")}
                        </Table.Title>
                        <Table.Title numeric style={styles.inputRow}>
                            {t("common.account_number", "Account number")}
                        </Table.Title>
                    </Table.Header>
                    {chartOfAccounts.map((item, index) => (
                        <Table.Row
                            key={index.toString()}
                            style={
                                index % 2 === 0
                                    ? theme.styles.oddRow
                                    : undefined
                            }
                        >
                            <Table.Cell>{item.name}</Table.Cell>
                            <Table.Cell numeric style={styles.inputRow}>
                                <NumberInput
                                    value={item.merchantAccountNo}
                                    onChange={newValue =>
                                        changeMerchantAccountNo(
                                            newValue,
                                            item.merchantAccountNo
                                        )
                                    }
                                    min={0}
                                    max={100000}
                                    style={styles.input}
                                />
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table>
            ) : (
                <>
                    <View>
                        <Text>
                            {t(
                                "backoffice.integration.economic.no_account_chart",
                                "No custom account chart. Using defaults."
                            )}
                        </Text>
                    </View>
                    <Spacer space={2} />
                </>
            )}
        </View>
    );
}

const styleFunc: StyleFunction = theme => ({
    container: {
        width: "100%",
        maxWidth: theme.dimensions.maxFormWidth,
        alignSelf: "flex-start",
    },
    input: {
        marginBottom: 0,
    },

    inputRow: {
        flexBasis: 160,
        flexGrow: 0,
        flexShrink: 0,
    },
});
